import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MODAL_STATE, TOASTER_STATE } from '../Model/Enums';

type LayoutStore = {
  modalVisibility: boolean;
  modalState: MODAL_STATE;
  toasterState: TOASTER_STATE;
  fullDropZone: boolean;
  toasterMessage: string;
  overLayerVisible: boolean;
  popupBlocked: boolean;
  showTaxNumber: boolean;
};

export const layoutSlice = createSlice({
  name: 'layout',
  initialState: { overLayerVisible: false, showTaxNumber: true } as LayoutStore,
  reducers: {
    toggleModal: (state) => {
      state.modalVisibility = !state.modalVisibility;
    },
    changeModalState: (state, { payload }: PayloadAction<MODAL_STATE>) => {
      state.modalState = payload;
      state.modalVisibility = true;
    },
    changeToasterState: (state, { payload }: PayloadAction<TOASTER_STATE>) => {
      state.toasterState = payload;
    },
    setFullDropZone: (state, { payload }: PayloadAction<boolean>) => {
      state.fullDropZone = payload;
    },
    toggleOverLayer: (state, { payload }) => {
      state.overLayerVisible = payload;
    },
    addToasterMessage: (state, { payload }) => {
      state.toasterMessage = payload;
    },
    isPopupBlocking: (state, { payload }: PayloadAction<boolean>) => {
      state.popupBlocked = payload;
    },
    showTaxNumber: (state, { payload }: PayloadAction<boolean>) => {
      state.showTaxNumber = payload;
    },
  },
});

export const {
  toggleModal,
  changeModalState,
  setFullDropZone,
  changeToasterState,
  toggleOverLayer,
  addToasterMessage,
  isPopupBlocking,
  showTaxNumber,
} = layoutSlice.actions;

export const layoutReducer = layoutSlice.reducer;

export const modalVisibilitySelector = createSelector(
  (state) => state.layout.modalVisibility,
  (modalVisibility) => modalVisibility
);

export const fullDropZoneSelector = createSelector(
  (state) => state.layout.fullDropZone,
  (fullDropZone) => fullDropZone
);

export const modalStateSelector = createSelector(
  (state) => state.layout.modalState,
  (modalState) => modalState
);

export const toasterStateSelector = createSelector(
  (state) => state.layout.toasterState,
  (toasterState) => toasterState
);

export const toasterMessageSelector = createSelector(
  (state) => state.layout.toasterMessage,
  (toasterMessage) => toasterMessage
);

export const overLayerSelector = createSelector(
  (state) => state.layout.overLayerVisible,
  (overLayerVisible) => overLayerVisible
);

export const popupBlockedSelector = createSelector(
  (state) => state.layout.popupBlocked,
  (popupBlocked) => popupBlocked
);

export const showTaxNumberSelector = createSelector(
  (state) => state.layout.showTaxNumber,
  (showTaxNumber) => showTaxNumber
);
